import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Publicacion`

export function buscarTodas(buscar) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las publicaciones.',
      tipoError: 'publicaciones'
    }
  })
}

export function buscarTodasOptimizado(idComprador, idVendedor, idCategoria, buscar) {
  return http.get(
    `${API_ENDPOINT}/BuscarTodosOptimizado/${idComprador}/${idVendedor}/${idCategoria}/${buscar}`,
    {
      meta: {
        toastMessage: 'Ocurrió un error al obtener las publicaciones.',
        tipoError: 'publicaciones'
      }
    }
  )
}

export function buscarPorVendedor(idVendedor, buscar) {
  return http.get(`${API_ENDPOINT}/buscarPorVendedor/${idVendedor}/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las publicaciones.',
      tipoError: 'publicaciones'
    }
  })
}

export function buscarPorTiendaOficial(idComprador, idVendedor, idCategoria, buscar) {
  return http.get(
    `${API_ENDPOINT}/BuscarPorTiendaOficial/${idComprador}/${idVendedor}/${idCategoria}/${buscar}`,
    {
      meta: {
        toastMessage: 'Ocurrió un error al obtener las publicaciones.',
        tipoError: 'publicaciones'
      }
    }
  )
}

export function buscarPorId(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarPorId/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la publicación.',
      tipoError: 'publicaciones'
    }
  })
}

export function buscarDetalle(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarDetalle/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la publicación.',
      tipoError: 'publicaciones'
    }
  })
}

export function subirAdjunto(datosForm) {
  return http.post(`${API_ENDPOINT}/Upload`, datosForm)
}

export function BuscarImagen(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarImagenPorPublicacion/${idPublicacion}`, {
    responseType: 'blob'
  })
}

export function BuscarImagenPorAdjunto(idUsuario, idPublicacion, idAdjunto) {
  return http.get(
    `${API_ENDPOINT}/BuscarImagenPorAdjunto/${idUsuario}/${idPublicacion}/${idAdjunto}`,
    {
      responseType: 'blob'
    }
  )
}

export function buscarAdjuntos(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarAdjuntos/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los adjuntos',
      tipoError: 'adjuntos'
    }
  })
}

export function eliminarAdjunto(idUsuario, idPublicacion, idAdjunto) {
  return http.delete(`${API_ENDPOINT}/Eliminar/${idUsuario}/${idPublicacion}/${idAdjunto}`)
}

export function actualizar(publicacion) {
  return http.put(API_ENDPOINT, publicacion)
}

export function buscarMoneda() {
  return http.get(`${API_ENDPOINT}/BuscarMoneda`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la moneda.',
      tipoError: 'moneda'
    }
  })
}

export function buscarMedioPago() {
  return http.get(`${API_ENDPOINT}/BuscarMedioPago`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los medios de pago.',
      tipoError: 'medioPago'
    }
  })
}

export function BuscarMedioPagoPublicacion(idPublicacion, idPresupuesto) {
  return http.get(`${API_ENDPOINT}/BuscarMedioPagoPublicacion/${idPublicacion}/${idPresupuesto}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los medios de pago.',
      tipoError: 'medioPago'
    }
  })
}

export function buscarMetadatos(idsPublicaciones) {
  if (Array.isArray(idsPublicaciones)) {
    return http.post(
      `${API_ENDPOINT}/BuscarMetadatoLote`,
      { idsPublicacion: idsPublicaciones },
      {
        meta: {
          toastMessage: 'Ocurrió un error al obtener las características.',
          tipoError: 'caracteristicas'
        }
      }
    )
  }
}

export function buscarMetadato(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarMetadato/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las características.',
      tipoError: 'caracteristicas'
    }
  })
}

export function InsertarMetadato(metadato) {
  return http.post(`${API_ENDPOINT}/InsertarMetaDato`, metadato)
}

export function buscarMedioEnvio() {
  return http.get(`${API_ENDPOINT}/BuscarMedioEnvio`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los medios de envío.',
      tipoError: 'medioEnvio'
    }
  })
}

export function buscarGarantia() {
  return http.get(`${API_ENDPOINT}/BuscarGarantia`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las garantías.',
      tipoError: 'garantia'
    }
  })
}

export function buscarUnidad() {
  return http.get(`${API_ENDPOINT}/BuscarUnidad`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las unidades.',
      tipoError: 'unidad'
    }
  })
}

export function buscarExposicion(buscar) {
  return http.get(`${API_ENDPOINT}/BuscarExposicion/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las exposiciones.',
      tipoError: 'exposicion'
    }
  })
}

export function BuscarPorCategoria(idCategoria, ofertaDesde, ofertaHasta) {
  return http.get(
    `${API_ENDPOINT}/BuscarPorCategoria/${idCategoria}/${ofertaDesde}/${ofertaHasta}`,
    {
      meta: {
        toastMessage: 'Ocurrió un error al obtener la categoría.',
        tipoError: 'categorias'
      }
    }
  )
}

export function buscarPorSubCategoria(idCategoria, buscar) {
  return http.get(`${API_ENDPOINT}/BuscarPorSubCategoria/${idCategoria}/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la subcategoría.',
      tipoError: 'categorias'
    }
  })
}

export function BuscarOfertas(idComprador, idVendedor, idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarOfertas/${idComprador}/${idVendedor}/${idCategoria}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las ofertas.',
      tipoError: 'ofertas'
    }
  })
}

export function BuscarDetalle(idPublicacion, idVendedor) {
  return http.get(`${API_ENDPOINT}/BuscarDetalle/${idPublicacion}/${idVendedor}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el detalle.',
      tipoError: 'publicaciones'
    }
  })
}

export function BuscarMediosDePago(idPublicacion) {
  return http.get(`${API_ENDPOINT}/MediosPago/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los medios de pago.',
      tipoError: 'medioPago'
    }
  })
}

export function AplicarDescuentoPorLista(idListaVenta) {
  return http.post(`${API_ENDPOINT}/AplicarDescuentoPorLista/${idListaVenta}`)
}

export function BuscarPublicacionesPorLista(idListaVenta) {
  return http.get(`${API_ENDPOINT}/BuscarPublicacionesPorLista/${idListaVenta}`)
}

export function ActualizarPublicacionDeLista(publicacion) {
  return http.put(`${API_ENDPOINT}/ActualizarPublicacionDeLista`, publicacion)
}

export function aplicarVariacionPrecio(data) {
  return http.post(`${API_ENDPOINT}/AplicarVariacionPrecio`, data)
}

export function ActualizarPublicacionIndividual(publicacion) {
  return http.put(`${API_ENDPOINT}/ActualizarPublicacionesIndividuales`, {
    publicaciones: [publicacion]
  })
}

export function actualizarEstado(idPublicacion, idVendedor, idPublicacionEstado) {
  return http.put(`${CONS.API_ENDPOINT_EBM}/PublicacionEstado`, {
    idPublicacion,
    idVendedor,
    idPublicacionEstado
  })
}
